import { applicationInsights } from '../../ApplicationInsights';
import { BusinessProfileApi } from './BusinessProfileApi';
import { ApiErrorKind } from './errors';
import { mockFailures, withFailureInjection } from './failureInjection';
import { IBusinessProfileApi } from './IBusinessProfileApi';

export type { IBusinessProfileApi } from './IBusinessProfileApi';
export { BusinessProfileApi } from './BusinessProfileApi';

// TODO: Still exported, and still a complete implementation of the interface: screens 3-7 are
// hidden rather than deleted, so the mock is what they will be developed against until those
// endpoints exist. Nothing in the shipped app uses it.
export { MockBusinessProfileApi } from './mockBusinessProfileApi';

const api = new BusinessProfileApi(applicationInsights);

export const businessProfileApi: IBusinessProfileApi = import.meta.env.DEV
    ? withFailureInjection(api)
    : api;

// Console handle for exercising error and loading states; see ./failureInjection.ts
// TODO: Remove after development is done
if (import.meta.env.DEV) {
    (window as unknown as Record<string, unknown>).bpMock = {
        failures: mockFailures,
        kinds: ApiErrorKind,
    };
}
